import classNames from 'classnames';

interface PaddingExampleProps {
    className: string;
}

export const PaddingExample = ({ className }: PaddingExampleProps) => (
    <div className={classNames('sds_padding', className)} />
);
